import { Outlet } from "react-router-dom";
import { PublicNav } from "./PublicNav";
import { PublicFooter } from "./PublicFooter";

/**
 * PublicLayout — Layout wrapper for marketing / public pages
 *
 * No SessionGate, no useSessionRestore, no DesktopGate.
 * Clean light-themed shell with PublicNav header + PublicFooter.
 */
export function PublicLayout() {
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col">
      <PublicNav />

      {/* pt-16 md:pt-20 offsets the fixed PublicNav height */}
      <main className="flex-1 pt-16 md:pt-20">
        <Outlet />
      </main>

      <PublicFooter />
    </div>
  );
}
